/**
 * Types and mappings for interactive league preview functionality.
 * Used to connect preview card elements to their corresponding editor sections/fields.
 */

// Element identifiers for interactive preview
export type LeaguePreviewElement =
  | 'logo'
  | 'name'
  | 'orgName'
  | 'description'
  | 'competitionLevel'
  | 'playDays'
  | 'format'
  | 'season';

// Accordion section identifiers
export type LeagueEditorSection = 'general' | 'eventDefaults';

// Field identifiers within sections
export type LeagueFieldTarget =
  | 'name'
  | 'logo'
  | 'orgName'
  | 'description'
  | 'competitionLevel'
  | 'playDays'
  | 'format';

// Mapping from preview element to section/field
export const LEAGUE_ELEMENT_TO_EDITOR: Record<
  LeaguePreviewElement,
  { section: LeagueEditorSection; field?: LeagueFieldTarget }
> = {
  logo: { section: 'general', field: 'logo' },
  name: { section: 'general', field: 'name' },
  orgName: { section: 'general', field: 'orgName' },
  description: { section: 'general', field: 'description' },
  competitionLevel: { section: 'general', field: 'competitionLevel' },
  playDays: { section: 'eventDefaults', field: 'playDays' },
  format: { section: 'general', field: 'format' },
  season: { section: 'general' },
};
